import type { FaireProductEntity } from "../../entity_types/product";

export const p_642nhms3bk: FaireProductEntity = {
  token: "p_642nhms3bk",
  type: "product",
  name: "Pickleball Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/6eca4976c78b473f8bbdda271309382b9b0980980018367cbc9caea9c4fe94a1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9e63b7c5c28557824b09731e90eaa362121fb0551f3bbbc323f7a76f84337ca9.jpeg",
    "https://cdn.faire.com/fastly/107155969985639a3a5faccb12357c2d686df22bf4e62803ebebaacaa64ac3ad.jpeg",
    "https://cdn.faire.com/fastly/db6a237a275a6417b097389a0fb52881a297b2f3bb059e08bbeee97a4b900d7c.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:42.799Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
